import { connect } from 'react-redux';
import ReactGA from 'react-ga';
import { withRouter } from 'react-router';
import Selector from '../components/reports/Selector';
import { getFilteredTypes, getUserOptions } from '../selectors/reports';

import {
  reportTypes,
  timeOptions,
  selectTimeFilter,
  selectReportType,
  selectStartCustomDate,
  selectEndCustomDate,
  openScheduleReportModal,
  selectUserFilter,
} from '../actions/reports';

const mapStateToProps = (state, ownProps) => ({
  mainOptions: getFilteredTypes(state),
  timeOptions: timeOptions,
  userOptions: getUserOptions(state),
  startCustom: state.reports.startCustom,
  endCustom: state.reports.endCustom,
  mainSelectIndex: state.reports.reportSelectIndex,
  timeSelectIndex: state.reports.timeSelectIndex,
  userSelectIndex: state.reports.userSelectIndex,
  account_id: state.account.selected,
  timezone: state.account.time_zone,
  reportSelect: state.reports.reportSelect,
  timeSelect: state.reports.timeSelect,
  rows: state.reports.filters.rows,
  index: state.reports.filters.index,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  init: mainOptions => {
    dispatch(selectReportType(1, mainOptions));
  },
  mainSelectHandler: (value, mainOptions) => {
    ReactGA.event({
      category: 'Reports',
      action: 'Report selected: ' + reportTypes[value]['key'],
    });
    dispatch(selectReportType(value, mainOptions));
  },
  timeSelectHandler: value => {
    ReactGA.event({
      category: 'Reports',
      action: 'Time selected: ' + timeOptions[value]['key'],
    });
    dispatch(selectTimeFilter(value));
  },
  userSelectHandler: index => {
    dispatch(selectUserFilter(index));
  },
  startCustomSelectHandler: date => {
    dispatch(selectStartCustomDate(date));
  },
  endCustomSelectHandler: date => {
    dispatch(selectEndCustomDate(date));
  },
  executeHandler: (type, range, rows, index, user) => {
    ReactGA.event({
      category: 'Reports',
      action: 'Ran report',
    });
    let user_params = 0;
    if (user) {
      user_params = user;
    }
    console.log('the users: ', user_params, user);
    const url =
      '/view_report/' +
      type +
      '/' +
      range +
      '/' +
      rows +
      '/' +
      index +
      '/' +
      user_params;
    window.open(url, '_blank');
  },
  openModal: mainOptions => {
    dispatch(openScheduleReportModal(mainOptions));
  },
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Selector)
);
